import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Button from '@mui/material/Button';
import { PRIMARY_COLORS } from '../../common/colors';

// Webflow ".button.is-secondary": outlined pill, brand border and text,
// light-brand fill on hover.
const SecondaryButton = ({ to, href, sx, children, ...rest }) => (
  <Button
    {...(to ? { component: RouterLink, to } : { href })}
    sx={{
      border: '1px solid',
      borderColor: 'primary.main',
      color: 'primary.main',
      whiteSpace: 'nowrap',
      '&:hover': { backgroundColor: PRIMARY_COLORS['95'], color: PRIMARY_COLORS['30'] },
      ...sx,
    }}
    {...rest}>
    {children}
  </Button>
);

export default SecondaryButton;
